import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API } from '../constants/api';
import { Entity } from './types';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: API.localUrl }),
  endpoints: (build) => ({
    getEntityByName: build.query<Entity, string>({
      query: (name) => `todos/${name}`,
    }),
  }),
});
// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetEntityByNameQuery } = api;
// Accessing api hooks directly
// const useGetEntityByNameQuery = api.endpoints.getEntityByName.useQuery
